import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import 'select2';

export default class extends Controller {
  static targets = [
    'destinationSelect', 'addDestinationButton', 'restaurantType',
    'bookingType', 'restaurantDropdown', 'destinationDropdown'
  ]

  connect() {
    this.MODAL_OBJECT = '';
  }

  newOverride(event) {
    const dataset = event.target.dataset;
    document.MODAL_UUID = dataset.modalUuid;
    document.RESTAURANTS_DESTINATIONS = JSON.parse(dataset.restaurantsDestinations);
    document.RESTAURANTS = JSON.parse(dataset.restaurants);

    if (this.MODAL_OBJECT === '') {
      this.setModal();
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    this.presentModal();
  }

  setModal() {
    this.MODAL_BACKGROUND = document.getElementById('VC-MODAL-BG');
    this.MODAL_OBJECT = document.getElementById(`modal-${document.MODAL_UUID}`);
    this.populateRestaurantDropdown();
  }

  handleRestaurantDropdownChange() {
    this.populateDestinationDropdown();
    this.handleNextButton();
  }

  populateDestinationDropdown() {
    const container = document.querySelector(`#modal-${document.MODAL_UUID}`)
    let destinationSelect = container.querySelector('#override_destination_id');
    let restaurantSelect = container.querySelector('#override_restaurant_id');
    const placeholder = 'Select a Destination';
    destinationSelect.innerText = ''
    destinationSelect.appendChild(new Option(placeholder, ''))

    if (restaurantSelect.selectedIndex !== 0) {
      this.populateDropdown(
        document.RESTAURANTS_DESTINATIONS[Number(restaurantSelect.value)],
        destinationSelect
      );
    }

    this.initSelect2(placeholder);
  }

  populateRestaurantDropdown() {
    const container = document.querySelector(`#modal-${document.MODAL_UUID}`)
    let restaurantSelect = container.querySelector('#override_restaurant_id');
    this.populateDropdown(document.RESTAURANTS, restaurantSelect);
  }

  populateDropdown(entries, selector) {
    for (const key in entries) {
      if (entries[key]) {
        let option = document.createElement('option');
        let entry = entries[key];

        option.text = entry[0];
        option.value = entry[1];
        selector.appendChild(option);
      }
    }
  }

  presentModal() {
    this.MODAL_BACKGROUND.classList.remove('hidden');
    this.MODAL_OBJECT.classList.remove('hidden');
  }

  showDestination() {
    this.destinationSelectTarget.classList.remove('hidden');
    this.addDestinationButtonTarget.classList.add('hidden');
    this.initSelect2('Select a Destination');
  }

  handleNextButton() {
    const container = document.querySelector(`#modal-${document.MODAL_UUID}`)
    let nextButton = container.querySelector('#OVERRIDE_NEXT_BTN');

    if (this.bookingTypeTarget.checked) {
      nextButton.setAttribute('disabled', true);
    }

    if (this.restaurantTypeTarget.checked) {
      if (this.restaurantTypeTarget.checked && this.restaurantDropdownTarget.selectedIndex !== 0) {
        nextButton.removeAttribute('disabled');
      } else {
        nextButton.setAttribute('disabled', true);
      }
    }
  }

  initSelect2(placeholder) {
    $('.select2').select2({
      allowClear: true,
      placeholder
    })
  }

  resetForm() {
    this.destinationSelectTarget.classList.add('hidden');
    this.addDestinationButtonTarget.classList.remove('hidden');
    this.restaurantDropdownTarget.selectedIndex = 0;
    this.destinationDropdownTarget.selectedIndex = 0;

    $('.select2').empty();
    this.handleNextButton();
  }

  handleCancelButton(e) {
    e.preventDefault();
    this.resetForm();
    document.getElementById('VC-MODAL-BG').classList.add('hidden')
    document.getElementById(`modal-${document.MODAL_UUID}`).classList.add('hidden')
  }
}
